import { render, staticRenderFns } from "./VolunteerProfileCausesDialog.vue?vue&type=template&id=879e4b74&scoped=true"
import script from "./VolunteerProfileCausesDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileCausesDialog.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileCausesDialog.vue?vue&type=style&index=0&id=879e4b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e4b74",
  null
  
)

export default component.exports